import React from 'react'

import classNames from 'classnames'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'

const MAX_PAGE = 3

const PaginationComponent = ({ n, selected: serverSelected, onPageChange, className }) => {

  // Local state to handle the client-side selected value
  const [selected, setSelected] = React.useState(serverSelected)

  // Update selected on client-side after hydration
  React.useEffect(() => {
    setSelected(serverSelected)
  }, [serverSelected])

  if (typeof window === 'undefined') {
    // this is probably going to lead hydration issues but it's the best we can do for now
    // otherwise page is not properly selected on first load
    return ""
  }

  const paginationItems = []
  if (n > 1) {
    if (selected > 0)
      paginationItems.push(
        <PaginationItem key='left'>
          <PaginationLink
            type='button'
            onClick={() => {
              onPageChange(selected - 1)
            }}
          >
            <i className='fa fa-angle-left' />
          </PaginationLink>
        </PaginationItem>
      )
    for (
      let i = Math.max(selected - MAX_PAGE, 0);
      i < Math.min(selected + MAX_PAGE + 1, n);
      i++
    ) {
      paginationItems.push(
        <PaginationItem key={i} className={i == Number(selected) ? 'active' : ''}>
          <PaginationLink
            type='button'
            onClick={() => {
              onPageChange(i)
            }}
          >
            {i + 1}
          </PaginationLink>
        </PaginationItem>
      )
    }
    if (selected < n - 1)
      paginationItems.push(
        <PaginationItem key='right'>
          <PaginationLink
            type='button'
            onClick={() => {
              onPageChange(selected + 1)
            }}
          >
            <i className='fa fa-angle-right' />
          </PaginationLink>
        </PaginationItem>
      )
  }
  return (
    <Pagination
      aria-label='Page navigation example'
      className={classNames('d-flex justify-content-center', className)}
    >
      {paginationItems}
    </Pagination>
  )
}

export default PaginationComponent
